import { DynamicMedia } from "@client/content/controls/Media/component";
import { type ModuleApiInfo } from "@client/content/selectors";
import Modal from "@client/controls/Modal/container";
import { type WithId } from "@client/types";
import SubmitButton from "@common/controls/Form/Buttons/Submit";
import { FormButtons } from "@common/controls/Form/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type Leaderboard } from "../../../types";
import Header from "../../ModalHeader/container";

export type MapProps = WithId & {
  apiInfo: ModuleApiInfo;
  error: string | null;
  isApplying: boolean;

  isMember: boolean;
  mediaId: string | null;
  item: Leaderboard.Item;
};

export interface ActionProps {
  onApply: () => void;
  onShowProfile: () => void;
  onClose: () => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Modal
      className="cartly_content_leaderboard_vote second"
      hasBackdrop
      isAdminColor={false}
      isDraggable={false}
      isCentered
      isInViewport
      isLoading={false}
      isVisible={true}
      width={500}
      onClose={props.onClose}
      closeBehaviour={props.isApplying ? "not-allowed" : undefined}
    >
      <Modal.Header>
        {({ onCloseClick }) => <Header onCloseClick={onCloseClick} id={props.id} item={props.item} />}
      </Modal.Header>
      <Modal.Body>
        {props.mediaId && <DynamicMedia apiInfo={props.apiInfo} id={props.mediaId} />}
        {/* {!props.isMember && <h4 className="apply_heading" dangerouslySetInnerHTML={{__html: i18n.applyToBecomeMember}} />} */}
        {/* {<p className="instruction" dangerouslySetInnerHTML={{__html: props.isMember ? i18n.secondStepBodyMember : i18n.secondStepBodyNotMember}} />} */}

        <FormButtons>
          {props.isMember ? (
            <SubmitButton onClick={props.onShowProfile}>{i18n.apply}</SubmitButton>
          ) : (
            <SubmitButton isDisabled={props.isApplying} onClick={props.onApply}>
              {i18n.apply}
            </SubmitButton>
          )}
        </FormButtons>

        {props.error && <div className="error_box">{props.error}</div>}
      </Modal.Body>
    </Modal>
  );
};
